import axios from "axios";
import { joinURLs } from "../utils/urlUtil";
import { getHeadersConfig } from "../utils/config";
import qs from 'qs';
import { ClinkResponseDto } from "../utils/types";
import { ResponseStatus } from "../utils/types";
import dayjs from "../utils/dayjs";
import ErrorHandler from "../utils/ErrorHandler";
import COUNTRIES from "../components/countries";

let addCLinksAbortController = new AbortController();
let getClinkAbortController = new AbortController();
let updateClinkAbortController = new AbortController();

export const Clinks = {
  getClink: async (clinkId: string, setClinkResponseDto:(linkResponseDto:ClinkResponseDto) => void) => {
    if (getClinkAbortController) getClinkAbortController.abort();
    getClinkAbortController = new AbortController();
  
    const url = joinURLs("admin/clinks", process.env.REACT_APP_JUPITER_API_BASE_URL);
    const params = {
      "clinkid": clinkId,
      "method": "getClink"
    };
    const responseDto:ClinkResponseDto = {
      status: ResponseStatus.LOADING, 
      error: null,
      clink: null
    };
    setClinkResponseDto(responseDto);

    try {
      const response:any = await axios.get(url, {...getHeadersConfig(), params, signal: getClinkAbortController.signal });
      const responseDto:ClinkResponseDto = {
        status: ResponseStatus.OK, 
        error: null,
        clink: null
      };

      const plats = response.data.configs[0].platforms;
      const data = response.data;
      const countries = COUNTRIES.filter((country) => data.configs[0].countries.split(",").find((countryId:string) => country.id === countryId));
  
      responseDto.clink = {
        clinkId:    data.clink_id,
        status:     data.configs[0].status.toLowerCase(),
        pubId:      data.pub_id,
        siteId:     data.site_id,
        appId:		  data.app_id,
        platforms:	plats,
        android:    plats?.indexOf('android') !== -1,
        iphone:     plats?.indexOf('iphone') !== -1,
        ipad:       plats?.indexOf('ipad') !== -1,
        p2p:        data.configs[0].p2p === null ? 0 : data.configs[0].p2p,
        minPayout:  data.configs[0].min_payout === null ? 0 : data.configs[0].min_payout,
        // munge the country string to be compatible with 
        // the tags-input directive
        // 'countries':  $scope.getCountries( data.configs[0].countries ),
        countries:  countries,
        dailyCap:   data.configs[0].daily_cap === null || typeof data.configs[0].daily_cap === "undefined" || data.configs[0].daily_cap === 0 ? 0 : data.configs[0].daily_cap,
        creator:    data.creator,
        campaigns:  data.configs[0].campaigns,
        created:    dayjs(data.created).utc(),
        lastUpdate: dayjs(data.last_update).utc(),
        incent:     data.incent,
        tags:       data.configs[0].tags ? data.configs[0].tags : [],
        ignorePlatforms: data.configs[0].ignorePlatforms,
        owner:           ( typeof data.owner === "undefined" || data.owner === null ) ? 'notset' : data.owner,
        previewLink:             data.previewLink,
        allowCounterBidOverride: data.configs[0].allow_counter_bid_override === true ? "allow" : ( data.configs[0].allow_counter_bid_override === false ? "disable" : "default" ),
        allowCounterBid:         data.configs[0].allow_counter_bid === true          ? "allow" : ( data.configs[0].allow_counter_bid === false          ? "disable" : "default" ),
        useRevShareP2p:          ( typeof data.configs[0].user_rev_share_p2p === "undefined" || data.configs[0].user_rev_share_p2p === null ) ? false : data.configs[0].user_rev_share_p2p
      };
      setClinkResponseDto(responseDto);
    } catch (error:any) {
      // handle error
      console.log(error);

      if (!axios.isCancel(error)) {
        const isLoggedOut:boolean = ErrorHandler.handleLoggedOutError(error);
        if (!isLoggedOut){
          const responseDto: ClinkResponseDto = {
            status: ResponseStatus.ERROR, 
            error: error?.response?.data?.errorMessage,           
            clink: null
          };
          setClinkResponseDto(responseDto);
        }
      }
    }
  },

  updateCLink: async (params:any) => {
    if (updateClinkAbortController) updateClinkAbortController.abort();
    updateClinkAbortController = new AbortController();
  
    const url = joinURLs("admin/clinks", process.env.REACT_APP_JUPITER_API_BASE_URL);
    try {
      const response:any = await axios({ url: url, method: "post", params, ...getHeadersConfig(), signal: updateClinkAbortController.signal });
      return response.data;
    } catch (error:any) {
      // handle error
      console.log('error', error);
      return { error };
    }
  },

  addClinks: async (params:any, setAddClinksIsLoading:any) => {
    if (addCLinksAbortController) addCLinksAbortController.abort();
    addCLinksAbortController = new AbortController();
  
    setAddClinksIsLoading(true);
    const url = joinURLs("admin/clinks", process.env.REACT_APP_JUPITER_API_BASE_URL);
    try {
      const response:any = await axios({ 
        url: url,
        method: "post",
        params,
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' }),
        ...getHeadersConfig(),
        signal: addCLinksAbortController.signal
      });

      return { data: response.data };
    } catch (error:any) {
      // handle error
      console.log('error', error);
      return { error };
    } finally {
      setAddClinksIsLoading(false);
    }
  }
}
